/**
 * GraphQL queries and hooks — diagram pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { Diagram } from '../types/diagram';

/**
 * Query to get every diagram documenting a given entity, via its
 * DOCUMENTED_BY edges (issue #1072/#1074/#1077). `content` is fetched lazily
 * from S3 server-side and typed as generic JSON here — `DiagramViewer`
 * validates its shape before rendering.
 */
export const GET_DIAGRAMS_FOR_ENTITY = gql`
  query GetDiagramsForEntity($entityId: ID!) {
    diagramsForEntity(entityId: $entityId) {
      entityId
      name
      description
      format
      type
      generationSource
      version
      tags
      content
      _createdAt
      _createdBy
      _updatedAt
      _updatedBy
    }
  }
`;

/**
 * Hook to get every diagram documenting an entity (issue #1077).
 */
export function useDiagramsForEntity(
  entityId: string
): QueryResult<{ diagramsForEntity: Diagram[] }> {
  return useQuery(GET_DIAGRAMS_FOR_ENTITY, {
    variables: { entityId },
    skip: !entityId,
  });
}
